module.exports = __webpack_public_path__ + "static/media/sauna-button.af2c9c1f.jpg";